import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';

export const useAccountantPortalWelcomeLogic = () => {
  const { navigateToNextPage } = useNavigationManager();

  const handleGetStarted = () => {
    navigateToNextPage(RoutesMap.ACCOUNTANT_PORTAL_WELCOME);
  };

  return {
    handleGetStarted,
    isLoading: false,
  };
};
